module.exports = __webpack_public_path__ + "static/img/Silver2.bf4c5c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Silver2.svg
// module id = qUox
// module chunks = 35